import { render, staticRenderFns } from "./DocOption.vue?vue&type=template&id=742cf589"
import script from "./DocOption.vue?vue&type=script&lang=js"
export * from "./DocOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports